import { render, staticRenderFns } from "./chatPDF-chat.vue?vue&type=template&id=16558b72&scoped=true&"
import script from "./chatPDF-chat.vue?vue&type=script&lang=js&"
export * from "./chatPDF-chat.vue?vue&type=script&lang=js&"
import style0 from "./chatPDF-chat.vue?vue&type=style&index=0&id=16558b72&scoped=true&lang=css&"
import style1 from "./chatPDF-chat.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16558b72",
  null
  
)

export default component.exports